/**
 *
 * Code
 *
 */

import React, { memo, FunctionComponent, useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import messages from './messages';
import {
  accentColorPrim,
  accentColorTertiary,
  fontColorSecond,
} from '../../../../assets/styledAssets/vars';
import {
  ComponentDialogBody,
  StyledDialogActionsBar,
  StyledModalAction,
} from '../../../../components/DiaogWrap/styles';
import { Column, Row, Wrap } from '../../../../assets/styledAssets/grid';
import Button from '../../../../components/Button/Button.component';
import {
  StyledDropDownList,
  StyledLabel,
} from '../../../../components/FormField/styles';
// import { CloseIcon } from '../../../../components/Icons/Icons.component';
import moment from 'moment';
import { Code } from '../../../../domains/app';

interface IProps {
  onCancel: () => void;
  generateCode: (min: number) => void;
  listCodes: Code[];
}

const AccessCode: FunctionComponent<IProps> = ({
  onCancel,
  generateCode,
  listCodes,
}) => {
  const intl = useIntl();
  const [min, setMin] = useState<number>(5);
  const [accessCodes, setAccessCodes] = useState<Code[]>(listCodes);
  const [listMinutes] = useState<any[]>(
    Array(30)
      .fill(1)
      .map((_, i) => (i + 1) * 5),
  );

  useEffect(() => {
    listCodes.forEach((c, i) => {
      const intervalId = setInterval(() => {
        setAccessCodes((accessCods) => {
          if (moment() < moment(c.expired)) {
            const duration = moment.duration(moment(c.expired).diff(moment()));
            const code: Code =
              accessCods.find((cod) => cod.id === c.id) || ({} as Code);
            code.timeLost = `${
              duration.hours() < 10 ? '0' + duration.hours() : duration.hours()
            }:${
              duration.minutes() < 10
                ? '0' + duration.minutes()
                : duration.minutes()
            }:${
              duration.seconds() < 10
                ? '0' + duration.seconds()
                : duration.seconds()
            }`;
          } else {
            if (c.intervalId) {
              clearInterval(c.intervalId);
            }
            accessCods = accessCods.filter((cod) => cod.id !== c.id);
          }
          return [...accessCods];
        });
      }, 1000);
      setAccessCodes(() => {
        listCodes[i].intervalId = intervalId;
        return [...listCodes];
      });
    });

    return () => {
      accessCodes.forEach((c) => {
        if (c.intervalId) {
          clearInterval(c.intervalId);
        }
      });
    };
    // eslint-disable-next-line
  }, [listCodes]);

  return (
    <>
      <ComponentDialogBody>
        <Row>
          <Column xs={100}>
            <Wrap alignItems={'center'} justifyCont={'space-between'}>
              <Wrap fs={'2.4rem'} fw={'bold'} color={accentColorPrim}>
                {intl.formatMessage(messages.title)}
              </Wrap>
            </Wrap>
          </Column>
        </Row>
        <Row>
          <Wrap margin={'3rem 0'} width={'100%'}>
            <Column xs={100} md={50}>
              <Wrap alignItems={'center'}>
                <Wrap flexDir={'column'}>
                  <StyledLabel>
                    {intl.formatMessage(messages.validFor)}
                  </StyledLabel>
                  <StyledDropDownList
                    data={listMinutes}
                    value={min}
                    onChange={(e) => setMin(e.value)}
                  />
                </Wrap>
                <Wrap
                  margin={'0 0 0 1.6rem'}
                  fs={'1.4rem'}
                  color={fontColorSecond}
                >
                  {intl.formatMessage(messages.minutes)}
                </Wrap>
              </Wrap>
            </Column>
          </Wrap>
          <Column xs={100}>
            <Wrap
              margin={'0 0 2rem 0'}
              padding={'0 0 2rem 0'}
              width={'100%'}
              borders={[{ side: 'bottom', color: fontColorSecond }]}
            >
              <Button onClick={() => generateCode(min)}>
                {intl.formatMessage(messages.createAccessCode)}
              </Button>
            </Wrap>
          </Column>
          <Column xs={100}>
            <Wrap margin={'2rem 0'} width={'100%'}>
              <Wrap fs={'2.4rem'} fw={'bold'}>
                {intl.formatMessage(messages.activeAccessCodes)}
              </Wrap>
            </Wrap>
            <Wrap width={'100%'} flexDir={'column'}>
              {accessCodes.map((item, index) => (
                <Wrap
                  key={'code' + index}
                  width={'100%'}
                  padding={'2rem 0'}
                  alignItems={'center'}
                  borders={[{ side: 'bottom', color: accentColorTertiary }]}
                >
                  <Wrap flexDir={'column'} grow={'1'}>
                    <Wrap
                      margin={'0 0 1rem 0'}
                      fs={'1.4rem'}
                      color={fontColorSecond}
                    >
                      {intl.formatMessage(messages.code)}
                    </Wrap>
                    <Wrap fs={'1.6rem'} fw={'bold'}>
                      {item.id}
                    </Wrap>
                  </Wrap>
                  <Wrap flexDir={'column'} grow={'1'}>
                    <Wrap
                      margin={'0 0 1rem 0'}
                      fs={'1.4rem'}
                      color={fontColorSecond}
                    >
                      {intl.formatMessage(messages.expirationTime)}
                    </Wrap>
                    <Wrap fs={'1.6rem'} fw={'bold'}>
                      {item.timeLost}
                    </Wrap>
                  </Wrap>
{/*                  <Button icon transparent>
                    <CloseIcon width={'1.4rem'} color={fontColorSecond} />
                  </Button>*/}
                </Wrap>
              ))}
            </Wrap>
          </Column>
        </Row>
      </ComponentDialogBody>
      <StyledDialogActionsBar>
        <StyledModalAction onClick={onCancel}>
          {intl.formatMessage(messages.cancel)}
        </StyledModalAction>
      </StyledDialogActionsBar>
    </>
  );
};

export default memo(AccessCode);
